<template>
  <div>

      <Banner></Banner>

      <BrandsLogos></BrandsLogos>

      <About></About>

      <Vistion></Vistion>

      <Advantages></Advantages>

      <WhyChooseUs></WhyChooseUs>

      <TypeDiv></TypeDiv>

      <Portfolio></Portfolio>

      <Const></Const>

  </div>
</template>

<script>
import Banner from '../../components/WebDevelopment/AngularDevelopment/Banner.vue'
import Vistion from '../../components/WebDevelopment/AngularDevelopment/Vistion.vue'
import Advantages from '../../components/WebDevelopment/AngularDevelopment/Advantages.vue'
import WhyChooseUs from '../../components/WebDevelopment/AngularDevelopment/WhyChooseUs.vue'
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue'
import Portfolio from '../../components/Home/Portfolio.vue'
import About from '../../components/WebDevelopment/AngularDevelopment/About.vue'
import TypeDiv from '../../components/Home/TypeDiv.vue'
import Const from '../../components/AssetComponents/Const.vue'

export default {
    components:{
        Banner,
        BrandsLogos,
        About,
        TypeDiv,
        Advantages,
        WhyChooseUs,
        Portfolio,
        Const,
        Vistion,
    }
}
</script>


<style>

</style>